import gql from 'graphql-tag';

export const CREATE_APPOINTMENT = gql`
  mutation(
    $contractId: Int!
    $subject: SubjectInput!
    $participants: [ParticipantInput!]!
    $schedule: ScheduleInput
    $allowedConversationTypes: [ConversationType!]
  ) {
    createAppointment(
      input: {
        contractId: $contractId
        participants: $participants
        schedule: $schedule
        allowedConversationTypes: $allowedConversationTypes
        subject: $subject
      }
    ) {
      appointmentId
      subject {
        user {
          userId
        }
      }
      service {
        name
      }
    }
  }
`;
